import { useMemo, useState } from 'react'
import { useLocation } from 'react-router'

export const useInitialQuery = () => {
  const { search } = useLocation()
  const [urlSearchParams] = useState<URLSearchParams>(
    new URLSearchParams(search)
  )

  return useMemo(() => urlSearchParams, [urlSearchParams])
}
